import React from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMagnifyingGlass,
  faXmark,
  faTruck,
  faCartShopping,
  faMoneyBillWave,
  faCommentsDollar,
  faShop,
  faStore,
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

import { Link } from 'app/src/utils/routing';
import { Text } from 'app/src/styles';
import * as colors from 'app/src/styles/colors';

const Container = styled(View)`
  flex-direction: row;
  column-gap: 10px;
  margin: 5px;
`;

const Name = styled(View)`
  width: 300px;
`;

const NameText = styled(Text)`
  font-weight: 600;
`;

const Detail = styled(View)`
  width: 300px;
`;

const AssetResult = ({ result }) => {
  return (
    <Link to={`/sellers/${result.seller.id}/assets/${result.id}`}>
      <Container>
        <FontAwesomeIcon
          icon={faTruck}
          color={colors.elRed}
        />
        <Name>
          <NameText>{result.name}</NameText>
        </Name>
        <Detail>
          <Text>
            {result.stockNumber} | {result.lastSix} |
            {result.clientNumber ? ` ${result.clientNumber} | ` : ' '}
            {result.seller.name}
          </Text>
        </Detail>
      </Container>
    </Link>
  );
};

const BuyerResult = ({ result }) => {
  return (
    <Link to={`/buyers/${result.id}`}>
      <Container>
        <FontAwesomeIcon
          icon={faCartShopping}
          color="navy"
        />
        <Name>
          <NameText>{result.fullDisplayName || result.name}</NameText>
        </Name>
      </Container>
    </Link>
  );
};

const BuyerUserResult = ({ result }) => {
  return (
    <Link to={`/buyers/${result.buyer.id}`}>
      <Container>
        <FontAwesomeIcon
          icon={faCartShopping}
          color="navy"
        />
        <Name>
          <NameText>{result.paddleNumberCache} | {result.fullNameCache}</NameText>
        </Name>
      </Container>
    </Link>
  );
};

const SaleAssetResult = ({ result }) => {
  const { asset } = result;
  return (
    <Link to={`/sellers/${asset.seller.id}/assets/${asset.id}`}>
      <Container>
        <FontAwesomeIcon
          icon={faCommentsDollar}
          color="purple"
        />
        <Name>
          <NameText>
            {result.lotNumber}{' '}
            {result.sale?.saleOn ?
              moment(result.sale.saleOn).format('M/D/YY') :
              ''
            }
            {' '}{asset.name}
          </NameText>
        </Name>
        <Detail>
          <Text>
            {asset.stockNumber} | {asset.lastSix} | {asset.seller.name}
          </Text>
        </Detail>
      </Container>
    </Link>
  );
};

const SaleResult = ({ result }) => {
  return (
    <Link to={`/sales/${result.id}`}>
      <Container>
        <FontAwesomeIcon
          icon={faMoneyBillWave}
          color="darkgreen"
        />
        <Name>
          <NameText>{result.name}</NameText>
        </Name>
      </Container>
    </Link>
  );
};

const SellerResult = ({ result }) => {
  return (
    <Link to={`/sellers/${result.id}`}>
      <Container>
        <FontAwesomeIcon
          icon={faShop}
          color={colors.elGreen}
        />
        <Name>
          <NameText>{result.name}</NameText>
        </Name>
      </Container>
    </Link>
  );
};

const VendorResult = ({ result }) => {
  return (
    <Link to={`/vendors/${result.id}`}>
      <Container>
        <FontAwesomeIcon
          icon={faStore}
          color="orange"
        />
        <Name>
          <NameText>{result.name}</NameText>
        </Name>
      </Container>
    </Link>
  );
};

const COMPONENT_MAP = {
  Asset: AssetResult,
  Buyer: BuyerResult,
  Sale: SaleResult,
  SaleAsset: SaleAssetResult,
  Seller: SellerResult,
  Vendor: VendorResult,
  BuyerUser: BuyerUserResult,
};

const Result = ({ result, setTerm, selected }) => {
  const ResultLink = COMPONENT_MAP[result.__typename];

  return (
    <Pressable
      onPress={() => setTerm('')}
      style={state => (
        { backgroundColor: (state.hovered || selected) ? 'lightgray' : 'none' }
      )}
    >
      <ResultLink result={result} />
    </Pressable>
  );
};

export default Result;
